import { Table as AntTable, Checkbox, Dropdown, Menu, TablePaginationConfig } from 'antd'
import { Key } from 'antd/es/table/interface'
import { ColumnType } from 'antd/lib/table'

import { useSharedState } from 'common/hooks'

import TableFilter from './TableFilter'

export type SizeType = 'small' | 'middle' | 'large' | undefined

export type TablePagination = TablePaginationConfig

export type TableColumns = (ColumnType<any> & { isStatic?: boolean })[]

type TableProps = {
  dataSource: object[]
  columns: TableColumns
  className?: string
  scroll?: {
    x?: number | true | string
    y?: number | string
  }
  size?: SizeType
  pagination?: false | TablePaginationConfig
  onChange?: (pagination: TablePagination, filters: any, sorter: any) => void
  loading?: boolean
  rowKey?: string | ((record: any) => string)
  onRow?: any
  footer?: any
  rowSelection?: any
} & ({ canFilterColumns?: false; name?: string } | { canFilterColumns: true; name: string })

export default function TableV2(props: TableProps) {
  const { columns, canFilterColumns = false, name, ...rest } = props
  const editableColumnsKeys = columns.filter((column) => !column.isStatic).map((column) => column.key)
  const [selectedColumns, setSelectedColumns] = useSharedState<Key[]>(
    `${name}-selected-columns`,
    editableColumnsKeys,
    true,
  )

  return (
    <>
      {canFilterColumns && (
        <div className="flex flex_justify_end w-100 mb-16">
          <TableFilter
            selectedColumns={selectedColumns}
            columns={columns}
            onSelectedColumnsChange={(e) => setSelectedColumns(e)}
          />
        </div>
      )}

      <AntTable
        columns={
          canFilterColumns
            ? columns.filter((column: any) =>
                [...selectedColumns, ...columns.filter((c) => c.isStatic).map((c) => c.key)].includes(column.key),
              )
            : columns
        }
        {...rest}
      />
    </>
  )
}
